/**
 * Exit-Webpade after successfully creating a Request
 */
import {CopyToClipboard} from "react-copy-to-clipboard";
import {faCopy} from "@fortawesome/free-regular-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const OutdoorExit = ({getUuid}) => {
    const uuid = getUuid()
    const json = JSON.parse(localStorage.getItem("json"))
    const buildings = JSON.parse(localStorage.getItem("buildings"))
    const customAntennas = JSON.parse(localStorage.getItem("customAntennas"))
    json.buildings = buildings
    json.customAntennas = customAntennas
    if(json["datarateUpLink"] === 0  && json["datarateDownLink"] === 0  && json["priorities"].length === 0){
        json["datarateDownLink"]= 100
        json["datarateUpLink"] = 50
    }
    var req = new XMLHttpRequest();
    req.open('POST', '/api/post', true);
    req.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    req.onreadystatechange = () => {
        // Call a function when the state changes.
        if (req.readyState === XMLHttpRequest.DONE) {
            window.location.replace(window.location.origin + "/" + uuid);
          // Request finished. Do processing here.
        }
      };
    req.send('uuid=' + uuid + '&data=' + JSON.stringify(json))
    localStorage.clear()
    return (
        <div className={"container"}>
            <div className={'text-center row'}>
                <div className={"col"}>
                    <div className={'my-5 px-3 py-1 d-inline-block bg-secondary text-white rounded-3'}>
                        <div className='fs-4'>Vielen Dank für Ihre Anfrage. In nur wenigen Minuten stellen wir Ihnen Ihr
                            automatisiert ermitteltes Planungsergebnis bereit. Den Status können Sie unter dem folgenden
                            Link abrufen:
                        </div>
                    </div>
                    <div className={'fs-4 my-5 px-3 py-1 d-inline-block bg-secondary text-white rounded-3'}>
                        <CopyToClipboard text={window.location.origin + "/" + uuid}><span>
                                <a style={{color: "white"}}
                                   href={window.location.origin + "/" + uuid}>{window.location.origin + "/" + uuid}</a>
                                <FontAwesomeIcon className={'hover ms-2'} icon={faCopy}/>
                            </span>
                        </CopyToClipboard>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OutdoorExit;